import { render, staticRenderFns } from "./VisitorLogForm.vue?vue&type=template&id=28910d0c"
import script from "./VisitorLogForm.vue?vue&type=script&lang=js"
export * from "./VisitorLogForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports